// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","445":"1bfc9850","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"351":"7bdab22875e740f9948d","445":"985ee6cddd3158feebc4","532":"edcc3e8b3155e067ed2d","678":"17f5d4e7256187ab307a","883":"7bef811d5f1ae17b7d79"}[chunkId] + ".js";
};